<rx-intuitive-bridge-editor
	[hasUnsavedChanges]="(hasUnsavedChanges$ | async) ?? false"
	[teeth]="(bridgeEditorTeeth$ | async) ?? []"
	[canEdit]="(canEditBridgeEditor$ | async) ?? false"
	[canDelete]="(toothEditorReadOnly$ | async) === false"
	[bridgeTeethFlat]="(bridgeTeethFlat$ | async) ?? []"
	[ponticDesigns]="(ponticDesigns$ | async) ?? []"
	[bridgeListItem]="bridgeListItem$ | async"
	(crownFormChanged)="onBridgeCrownFormChanged($event)"
	(additionalInfoApplied)="onBridgeAdditionalInfoApplied($event)"
	(clearDisabledFields)="onBridgeClearDisabledFields($event)"
	(ponticDesignChanged)="onPonticDesignChanged($event)"
	(delete)="onDeleteBridge()"
/>